import { autoRegisterFeature } from '@store/features/factory';

import { schedulingSettingsFeature } from './store/feature';

// Auto-register on import (same idiom as other features).
autoRegisterFeature(schedulingSettingsFeature);

export * from './components';
export * from './constants';
export * from './store';
export * from './types';
